module.exports = __webpack_public_path__ + "assets/email-icon.4628fddb.svg";